import { render, staticRenderFns } from "./AuthorListView.vue?vue&type=template&id=22c10c56&"
import script from "./AuthorListView.vue?vue&type=script&lang=js&"
export * from "./AuthorListView.vue?vue&type=script&lang=js&"
import style0 from "./AuthorListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports